/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";

import ConfirmationBox from "../../../../components/common/ConfirmationBox";
import PageHeading from "../../../../components/common/PageHeading";
import RightBar from "../../../../components/common/RightBar";
import RightBarMethod from "../../../../components/common/RightBar/RightBarMethod";

import { Card, Col, Row, Table } from "antd";

import { RiArrowDropDownLine, RiArrowDropUpLine } from "react-icons/ri";
import { FiRefreshCw } from "react-icons/fi";
import { HiPlusCircle } from "react-icons/hi";

import { codeboxLockBoxes, lockBoxes } from "../../../../data/guestcards";

import "./ManageLockboxes.css";
import { useNavigate } from "react-router-dom";

const LockBoxManagementRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Showings With CodeBox", "1", "", "", ""),
  ]),
  RightBarMethod(
    "HELP TOPICS",
    "t2",
    <i className="fa-solid fa-circle-question"></i>,
    [
      RightBarMethod(
        "Allow Prospects to Schedule Self-Guided Showings",
        "2",
        "",
        "",
        ""
      ),
    ]
  ),
];

function ManageLockboxes() {
  const [expended, setExpended] = useState();
  const [sortedInfo, setSortedInfo] = useState({});
  const [unlockCode, setUnlockCode] = useState("");
  const [lockBoxesData, setLockBoxesData] = useState(lockBoxes);
  const [lockBoxId, setLockBoxId] = useState(0);
  const [isConfirmationBoxOpen, setIsConfirmationBoxOpen] = useState(false);

  const navigate = useNavigate();

  const handleDelete = () => {
    setIsConfirmationBoxOpen(true);
  };

  const handleChange = (sorter) => {
    setSortedInfo(sorter);
  };

  const expend = (record) => {
    if (expended === record.key) setExpended(undefined);
    else setExpended(record.key);

    setUnlockCode(record.unlockCode);
    setLockBoxId(record.key);
  };

  const deleteLockBox = (key) => {
    const newArr = lockBoxesData.filter((item) => {
      return item.key !== key;
    });

    setLockBoxesData(newArr);
    setIsConfirmationBoxOpen(false);
  };

  const columns = [
    {
      title: "LockBox Name",
      dataIndex: "lockBoxName",
      key: "lockBoxName",
      sorter: (a, b) => a.lockBoxName.length - b.lockBoxName.length,
      sortOrder:
        sortedInfo.columnKey === "lockBoxName" ? sortedInfo.order : null,
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      sorter: (a, b) => a.unit.length - b.unit.length,
      sortOrder: sortedInfo.columnKey === "unit" ? sortedInfo.order : null,
      render: (text) => <span className="onclick-text">{text}</span>,
    },
    {
      dataIndex: "action",
      width: 20,
      render: (text, record) => {
        return (
          <div style={{ textAlign: "right" }}>
            <a onClick={() => expend(record)}>
              {record.key === expended ? (
                <RiArrowDropUpLine size={24} />
              ) : (
                <RiArrowDropDownLine size={24} />
              )}
            </a>
          </div>
        );
      },
    },
  ];

  const codeBoxLockBoxes = [
    {
      title: "Serial Number",
      dataIndex: "serialNumber",
      key: "serialNumber",
      sorter: (a, b) => a.serialNumber.length - b.serialNumber.length,
      sortOrder:
        sortedInfo.columnKey === "serialNumber" ? sortedInfo.order : null,
    },
    {
      title: "LockBox Name",
      dataIndex: "lockBoxName",
      key: "lockBoxName",
      sorter: (a, b) => a.lockBoxName.length - b.lockBoxName.length,
      sortOrder:
        sortedInfo.columnKey === "lockBoxName" ? sortedInfo.order : null,
    },
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      sorter: (a, b) => a.unit.length - b.unit.length,
      sortOrder: sortedInfo.columnKey === "unit" ? sortedInfo.order : null,
      render: (text) => <span className="onclick-text">{text}</span>,
    },
    {
      dataIndex: "action",
      width: 20,
      render: (text, record) => {
        return (
          <div style={{ textAlign: "right" }}>
            <span className="onclick-text" onClick={() => expend(record)}>
              {record.key === expended ? (
                <RiArrowDropUpLine size={24} />
              ) : (
                <RiArrowDropDownLine size={24} />
              )}
            </span>
          </div>
        );
      },
    },
  ];
  return (
    <>
      <div className="manage-lockboxes">
        <PageHeading heading="Manage Lockboxes" />
        <button className="add-lockbox-btn" onClick={() => navigate("/leasing/guest-cards/manage-lockboxes/add-lockbox")}>
          <HiPlusCircle size={18} />
          <span>Add Lockbox</span>
        </button>
        <div className="lockboxes-container">
          <Row>
            <Col span={24}>
              <Card title="Lockboxes">
                <div className="table-container ">
                  <Table
                    columns={columns}
                    dataSource={lockBoxesData}
                    onChange={handleChange}
                    expandable={{
                      expandedRowRender: () => (
                        <Row className="expanded-row" gutter={[0, 8]}>
                          <Col span={24}>
                            <span className="silver-text">Unclock Code</span>
                          </Col>
                          <Col span={24}>
                            <span>{unlockCode}</span>
                          </Col>
                          <Col span={24}>
                            <hr />
                          </Col>
                          <Col span={24} className="action-btns">
                            <span className="onclick-text">Edit</span>
                            <span
                              className="delete-btn"
                              onClick={() => handleDelete()}
                            >
                              Delete
                            </span>
                          </Col>
                        </Row>
                      ),
                      expandIcon: () => null,
                    }}
                    expandedRowKeys={[expended]}
                    footer={false}
                    pagination={false}
                  />
                </div>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Card title="CodeBox Lockboxes">
                <Row justify="space-between" align="middle">
                  <Col>
                    <strong>Account: </strong>
                    <span> rhett@integrityoklahoma.com</span>
                  </Col>
                  <Col>
                    <Row align="middle" gutter={[4, 0]}>
                      <Col>
                        <FiRefreshCw className="onclick-text" />
                      </Col>
                      <Col>
                        <span className="onclick-text">Refresh</span>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <div className="table-container">
                  <Table
                    columns={codeBoxLockBoxes}
                    dataSource={codeboxLockBoxes}
                    onChange={handleChange}
                    expandable={{
                      expandedRowRender: () => (
                        <Row className="expanded-row" gutter={[0, 8]}>
                          <Col span={24}>
                            <Row>
                              <Col span={4}>
                                <span className="silver-text">
                                  Shackle Code
                                </span>
                              </Col>
                              <Col span={4}>
                                <span className="silver-text">Vendor Code</span>
                              </Col>
                              <Col span={4}>
                                <span className="silver-text">Agent Code</span>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>
                            <Row>
                              <Col span={4}>
                                <span className="silver-text">--</span>
                              </Col>
                              <Col span={4}>
                                <span className="silver-text">--</span>
                              </Col>
                              <Col span={4}>
                                <span className="silver-text">--</span>
                              </Col>
                            </Row>
                          </Col>
                          <Col span={24}>
                            <hr />
                          </Col>
                          <Col span={24} className="action-btns">
                            <span className="onclick-text">Edit</span>
                          </Col>
                        </Row>
                      ),
                      expandIcon: () => null,
                    }}
                    expandedRowKeys={[expended]}
                    footer={false}
                    pagination={false}
                  />
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={LockBoxManagementRightBar} />
      </div>
      {isConfirmationBoxOpen ? (
        <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
          <p>Are you sure you want to delete this box ?</p>
          <hr />
          <div className="buttons-container">
            <span
              className="onclick-text"
              onClick={() => setIsConfirmationBoxOpen(false)}
            >
              Cancel
            </span>
            <span
              className="onclick-text"
              onClick={() => deleteLockBox(lockBoxId)}
            >
              <strong>Ok</strong>
            </span>
          </div>
        </ConfirmationBox>
      ) : null}
    </>
  );
}

export default ManageLockboxes;
